import { reportCrash } from '../services/crash-reporter.js';

// error-log.js — lightweight crash/error black box.
//
// Production me koi crash-reporting service nahi hai, isliye har uncaught
// error/promise-rejection ko localStorage me capture karte hain. User (ya aap)
// Settings → Diagnostics se last errors dekh/copy kar sakte hain — field me
// "app atak gayi" wali reports debug karne ka sabse sasta tareeka.
const MAX_ENTRIES = 25;
let _errorLog = [];
let _installed = false;

function loadErrorLog() {
  try {
    const data = localStorage.getItem('cs_error_log_v1');
    if (data) return JSON.parse(data);
  } catch (_) {}
  return [];
}

export function readErrorLog() {
  if (_errorLog.length === 0) _errorLog = loadErrorLog();
  return [..._errorLog];
}

export function clearErrorLog() {
  _errorLog = [];
  try { localStorage.removeItem('cs_error_log_v1'); } catch (_) {}
}

function persistErrorLog() {
  try {
    localStorage.setItem('cs_error_log_v1', JSON.stringify(_errorLog));
  } catch (_) {}
}

export function recordError(kind, message, stack) {
  try {
    const entry = {
      at: new Date().toISOString(),
      kind,
      message: String(message || '').substring(0, 500),
      stack: String(stack || '').substring(0, 1500),
      screen: (window.location.hash || '').slice(1) || 'home'
    };
    
    if (_errorLog.length === 0) _errorLog = loadErrorLog();
    _errorLog.unshift(entry);
    if (_errorLog.length > MAX_ENTRIES) _errorLog.pop();
    persistErrorLog();

    // Remote report
    try { reportCrash(entry); } catch (_) {}
  } catch (_) { /* the error logger must never itself crash the app */ }
}

export function installGlobalErrorHandlers() {
  if (_installed) return;
  _installed = true;
  window.addEventListener('error', (event) => {
    // Resource-load errors (img/script) have no error object — still useful.
    const err = event.error;
    recordError('error', event.message || (err && err.message) || 'Unknown error', err && err.stack);
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    recordError('promise', (reason && (reason.message || reason)) || 'Unhandled rejection', reason && reason.stack);
  });
}
